import React, {useEffect, useState} from 'react'
import {Card, Row, Col} from "antd";
import './style.css';

const IntroComp = () => {

    return (
        <div className="site-card-wrapper">
            <Card title="X-DETECT COVID Project Introduction"
                  cover={
                <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/p1.png?token=AI26VIF5XPDLYBZRA3BRGR3AC3QQ6"/>
            }
            >
                <Card type="inner" title="## Inspiration">
                    In the midst of a pandemic, we sense the grave urgency of patient treatment in order to prevent reaching full patient capacity in hospitals. As data scientists who are passionate about health and medicine, we wanted an easy tool that can be used by doctors and nurses to easily determine the severity of a patient's respiratory status based on chest radiographs. Our teammates who are experienced with front-end development are passionate about making the tool as user-friendly and accessible as possible.
                </Card>
                <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="## What it does"
                >
                    We have developed a web app to detect both the occurrence of COVID and pneumonia. To do this we have trained a series of machine learning algorithms (random forest, support vector machines, and logistic regression) to detect the presence of COVID; and a VGG16 based CNN to detect the presence of pneumonia. We achieve validation (training, validation, test) AUC of 0.99 and 0.97 for both predictions respectively. From a user perspective, a user would upload their X-ray image in .jpeg format and the web app returns a data-table of predictions from each model.
                </Card>
                <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="## How we built it"
                >
                    We sourced an open-source chest x-ray data set with labels for normal and pneumonia, and a subset of these individuals had labels for normal and COVID (n=6263, n= 166). We used python sklearn and tensorflow and keras to build our machine and deep learning models. We employed a random forest, support vector machine, and logistic regression model to predict the occurrence of COVID (since the data subset was small). We additionally built a VGG16 model for the pneumonia classification model. We then built a web app using flask and react. By using react framework to create a web app, and using the Flask framework as a 'middleman' we are able to connect the machine learning model to the frontend React.js website. Also, we utilized Render.com to deploy our REST API, which allows us to get prediction results from the model when the user uploading an image at the frontend website.                 </Card>
                <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="## Challenges we ran into"
                >
                    Within our team we had different domains of technical expertise and we found it difficult to blend the two. Half of our team were not familiar with front-end application whereas the other half were unfamiliar with machine learning. Needing to conduct our own research to ensure that both parts of our product was cohesive was a major challenge that we faced.
                </Card>
                <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="## What's next for X-Detect COVID"
                >
                    This innovative web-app has the potential to be incredibly useful for hospital staff to sieve through hundreds of X-ray scans a day to easily identify patients who need urgent treatment. However, a lot of work still has to be done including further testing to increase the accuracy of our predictions by using more testing samples or bootstrapping our models for them to be deployed to increase training time.
                </Card>
            </Card>
            <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={8}>
                    <Card title="" bordered={false}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/image0.png?token=AI26VIGEJEUWRSSLKHM7V63AC3OGO"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="" bordered={false}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/image1.png?token=AI26VIH7QPNRIIM4QBP5MUDAC3OGU"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="" bordered={false}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/image2.png?token=AI26VIFMA5JFXRU7QZGAKITAC3OHA"/>
                          }>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default IntroComp
